import { render, staticRenderFns } from "./keywords.vue?vue&type=template&id=3e3ad24f"
import script from "./keywords.vue?vue&type=script&lang=js"
export * from "./keywords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports